export enum Alignment {
  LEFT = 'left',
  RIGHT = 'right',
  NONE = 'none'
}
